/**
 * Generated by orval v6.22.1 🍺
 * Do not edit manually.
 * Home Charging Services API v1.0
 * OpenAPI spec version: v1.0
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { faker } from "@faker-js/faker";
import { HttpResponse, delay, http } from "msw";
import { profileInstance } from "../instances";
export type GetChargingSessionsGroupBy =
  (typeof GetChargingSessionsGroupBy)[keyof typeof GetChargingSessionsGroupBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetChargingSessionsGroupBy = {
  Day: "Day",
  Month: "Month",
} as const;

export type GetChargingSessionsParams = {
  /**
   * Format - date-time (as date-time in RFC3339).
   */
  startDate: string;
  /**
   * Format - date-time (as date-time in RFC3339).
   */
  endDate: string;
  groupBy: GetChargingSessionsGroupBy;
};

export interface StartChargingSessionResponse {
  sessionId?: string;
}

export type ScheduleError = (typeof ScheduleError)[keyof typeof ScheduleError];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScheduleError = {
  Unknown: "Unknown",
  ChargerIdNotProvided: "ChargerIdNotProvided",
  DaysOfWeekNotProvided: "DaysOfWeekNotProvided",
  DaysOfWeekInvalid: "DaysOfWeekInvalid",
  StartTimeNotProvided: "StartTimeNotProvided",
  StartTimeInvalid: "StartTimeInvalid",
  EndTimeNotProvided: "EndTimeNotProvided",
  EndTimeInvalid: "EndTimeInvalid",
  DescriptionInvalid: "DescriptionInvalid",
  MaximumSchedulesExceeded: "MaximumSchedulesExceeded",
  ScheduleConflict: "ScheduleConflict",
} as const;

export interface RegisterCustomerProfileRequest {
  firstName?: string;
  lastName?: string;
  mobile?: string;
}

export interface UpdateScheduleResponse {
  daysOfWeek?: DayOfWeek[];
  description?: string;
  endTime?: string;
  id?: string;
  startTime?: string;
}

export type TimePeriod = (typeof TimePeriod)[keyof typeof TimePeriod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TimePeriod = {
  Day: "Day",
  Month: "Month",
} as const;

export interface UpdateScheduleRequest {
  daysOfWeek?: DayOfWeek[];
  description?: string;
  endTime?: string;
  startTime?: string;
}

export interface ProblemDetailsOfGetChargingSessionsError {
  detail?: string;
  errors?: ErrorDetailOfGetChargingSessionsError[];
  instance?: string;
  status?: number;
  title?: string;
  type?: string;
  [key: string]: unknown;
}

export interface ProblemDetailsOfOverrideSchedulesError {
  detail?: string;
  errors?: ErrorDetailOfOverrideSchedulesError[];
  instance?: string;
  status?: number;
  title?: string;
  type?: string;
  [key: string]: unknown;
}

export interface ProblemDetailsOfCustomerProfileError {
  detail?: string;
  errors?: ErrorDetailOfCustomerProfileError[];
  instance?: string;
  status?: number;
  title?: string;
  type?: string;
  [key: string]: unknown;
}

export interface ProblemDetailsOfChargingSessionError {
  detail?: string;
  errors?: ErrorDetailOfChargingSessionError[];
  instance?: string;
  status?: number;
  title?: string;
  type?: string;
  [key: string]: unknown;
}

export interface ProblemDetailsOfChargerAdoptionError {
  detail?: string;
  errors?: ErrorDetailOfChargerAdoptionError[];
  instance?: string;
  status?: number;
  title?: string;
  type?: string;
  [key: string]: unknown;
}

export interface ProblemDetails {
  detail?: string;
  instance?: string;
  status?: number;
  title?: string;
  type?: string;
  [key: string]: unknown;
}

export type OverrideSchedulesError =
  (typeof OverrideSchedulesError)[keyof typeof OverrideSchedulesError];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OverrideSchedulesError = {
  Unknown: "Unknown",
  ChargerInvalidForOverridingSchedules: "ChargerInvalidForOverridingSchedules",
} as const;

export interface MarketingSubscriptionRequest {
  ampCharge?: boolean;
}

export interface Location {
  addressLine?: string;
  city?: string;
  id?: string;
  name?: string;
  postcode?: string;
  state?: string;
  timeZone?: string;
}

export interface LastChargeSession {
  endDateTime?: string;
  id?: string;
  startDateTime?: string;
  totalEnergyUsageInKwh?: number;
}

export type GetSchedulesResponseItem = {
  daysOfWeek?: DayOfWeek[];
  description?: string;
  endTime?: string;
  id?: string;
  startTime?: string;
};

export type GetSchedulesResponse = GetSchedulesResponseItem[];

export interface GetCustomerProfileResponse {
  contactId?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  mobile?: string;
}

export interface GetChargingSessionsResponse {
  date?: string;
  numberOfChargeSessions?: number;
  totalEnergyUsageInKwh?: number;
}

export type GetChargingSessionsError =
  (typeof GetChargingSessionsError)[keyof typeof GetChargingSessionsError];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetChargingSessionsError = {
  Unknown: "Unknown",
  ChargerIdNotProvided: "ChargerIdNotProvided",
  MaximumDateRangeExceeded: "MaximumDateRangeExceeded",
  StartDateCannotBeAfterEndDate: "StartDateCannotBeAfterEndDate",
} as const;

export interface GetChargersResponse {
  id?: string;
  name?: string;
  status?: ChargerStatus;
}

export interface GetChargerSummaryResponse {
  activeChargeSession?: ActiveChargeSession;
  eTag?: string;
  id?: string;
  lastChargeSession?: LastChargeSession;
  location?: Location;
  name?: string;
  serialNumber?: string;
  status?: ChargerStatus;
}

export interface ErrorDetailOfScheduleError {
  code?: ScheduleError;
  message?: string;
}

export interface ProblemDetailsOfScheduleError {
  detail?: string;
  errors?: ErrorDetailOfScheduleError[];
  instance?: string;
  status?: number;
  title?: string;
  type?: string;
  [key: string]: unknown;
}

export interface ErrorDetailOfGetChargingSessionsError {
  code?: GetChargingSessionsError;
  message?: string;
}

export interface ErrorDetailOfOverrideSchedulesError {
  code?: OverrideSchedulesError;
  message?: string;
}

export interface ErrorDetailOfCustomerProfileError {
  code?: CustomerProfileError;
  message?: string;
}

export interface ErrorDetailOfChargingSessionError {
  code?: ChargingSessionError;
  message?: string;
}

export interface ErrorDetailOfChargerAdoptionError {
  code?: ChargerAdoptionError;
  message?: string;
}

export type DayOfWeek = (typeof DayOfWeek)[keyof typeof DayOfWeek];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DayOfWeek = {
  Sunday: "Sunday",
  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  Saturday: "Saturday",
} as const;

export type CustomerProfileError =
  (typeof CustomerProfileError)[keyof typeof CustomerProfileError];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomerProfileError = {
  Unknown: "Unknown",
  FirstNameNotProvided: "FirstNameNotProvided",
  LastNameNotProvided: "LastNameNotProvided",
  MobileIsInvalid: "MobileIsInvalid",
} as const;

export interface CreateScheduleResponse {
  daysOfWeek?: DayOfWeek[];
  description?: string;
  endTime?: string;
  id?: string;
  startTime?: string;
}

export type ChargingSessionError =
  (typeof ChargingSessionError)[keyof typeof ChargingSessionError];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChargingSessionError = {
  Unknown: "Unknown",
  ChargerHasNoActiveSession: "ChargerHasNoActiveSession",
} as const;

export type ChargerStatus = (typeof ChargerStatus)[keyof typeof ChargerStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChargerStatus = {
  Unknown: "Unknown",
  Available: "Available",
  Charging: "Charging",
  StandBy: "StandBy",
  ManualCharging: "ManualCharging",
} as const;

export interface CreateScheduleRequest {
  daysOfWeek?: DayOfWeek[];
  description?: string;
  endTime?: string;
  startTime?: string;
}

export type ChargerAdoptionError =
  (typeof ChargerAdoptionError)[keyof typeof ChargerAdoptionError];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChargerAdoptionError = {
  Unknown: "Unknown",
  AdoptionKeyNotProvided: "AdoptionKeyNotProvided",
  AdoptionKeyMismatch: "AdoptionKeyMismatch",
  SerialNumberNotProvided: "SerialNumberNotProvided",
  SerialNumberNotFound: "SerialNumberNotFound",
  SerialNumberOwnedByAnotherUser: "SerialNumberOwnedByAnotherUser",
  SerialNumberNotRegistered: "SerialNumberNotRegistered",
  PurchaseDateInvalidMinimumPurchaseDate:
    "PurchaseDateInvalidMinimumPurchaseDate",
  PurchaseDateCannotBeInTheFuture: "PurchaseDateCannotBeInTheFuture",
} as const;

export interface AdoptChargerResponse {
  chargerId?: string;
}

export interface AdoptChargerRequest {
  adoptionKey?: string;
  chargerName?: string;
  purchaseDate?: string;
  serialNumber?: string;
}

export interface ActiveChargeSession {
  chargingRateInKw?: number;
  id?: string;
  startDateTime?: string;
  totalEnergyUsageInKwh?: number;
}

/**
 * Register customer profile
 * @summary Register customer profile
 */
export const registerCustomerProfile = (
  registerCustomerProfileRequest: RegisterCustomerProfileRequest,
) => {
  return profileInstance<void>({
    url: `/customer/profile`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: registerCustomerProfileRequest,
  });
};

export const getRegisterCustomerProfileMutationOptions = <
  TError = ProblemDetailsOfCustomerProfileError[],
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerCustomerProfile>>,
    TError,
    { data: RegisterCustomerProfileRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerCustomerProfile>>,
  TError,
  { data: RegisterCustomerProfileRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerCustomerProfile>>,
    { data: RegisterCustomerProfileRequest }
  > = (props) => {
    const { data } = props ?? {};

    return registerCustomerProfile(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterCustomerProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerCustomerProfile>>
>;
export type RegisterCustomerProfileMutationBody =
  RegisterCustomerProfileRequest;
export type RegisterCustomerProfileMutationError =
  ProblemDetailsOfCustomerProfileError[];

/**
 * @summary Register customer profile
 */
export const useRegisterCustomerProfile = <
  TError = ProblemDetailsOfCustomerProfileError[],
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerCustomerProfile>>,
    TError,
    { data: RegisterCustomerProfileRequest },
    TContext
  >;
}) => {
  const mutationOptions = getRegisterCustomerProfileMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get customer profile
 * @summary Get customer profile
 */
export const getCustomerProfile = (signal?: AbortSignal) => {
  return profileInstance<GetCustomerProfileResponse>({
    url: `/customer/profile`,
    method: "GET",
    signal,
  });
};

export const getGetCustomerProfileQueryKey = () => {
  return [`/customer/profile`] as const;
};

export const getGetCustomerProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerProfile>>,
  TError = ProblemDetails | void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCustomerProfile>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCustomerProfileQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerProfile>>
  > = ({ signal }) => getCustomerProfile(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCustomerProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerProfile>>
>;
export type GetCustomerProfileQueryError = ProblemDetails | void;

/**
 * @summary Get customer profile
 */
export const useGetCustomerProfile = <
  TData = Awaited<ReturnType<typeof getCustomerProfile>>,
  TError = ProblemDetails | void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCustomerProfile>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCustomerProfileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetCustomerProfileSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerProfile>>,
  TError = ProblemDetails | void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getCustomerProfile>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCustomerProfileQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerProfile>>
  > = ({ signal }) => getCustomerProfile(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getCustomerProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCustomerProfileSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerProfile>>
>;
export type GetCustomerProfileSuspenseQueryError = ProblemDetails | void;

/**
 * @summary Get customer profile
 */
export const useGetCustomerProfileSuspense = <
  TData = Awaited<ReturnType<typeof getCustomerProfile>>,
  TError = ProblemDetails | void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getCustomerProfile>>,
      TError,
      TData
    >
  >;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCustomerProfileSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Adopt a charger
 * @summary Adopt a charger
 */
export const adoptCharger = (adoptChargerRequest: AdoptChargerRequest) => {
  return profileInstance<AdoptChargerResponse>({
    url: `/chargers/adopt`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: adoptChargerRequest,
  });
};

export const getAdoptChargerMutationOptions = <
  TError = ProblemDetailsOfChargerAdoptionError[] | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adoptCharger>>,
    TError,
    { data: AdoptChargerRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adoptCharger>>,
  TError,
  { data: AdoptChargerRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adoptCharger>>,
    { data: AdoptChargerRequest }
  > = (props) => {
    const { data } = props ?? {};

    return adoptCharger(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdoptChargerMutationResult = NonNullable<
  Awaited<ReturnType<typeof adoptCharger>>
>;
export type AdoptChargerMutationBody = AdoptChargerRequest;
export type AdoptChargerMutationError =
  | ProblemDetailsOfChargerAdoptionError[]
  | void;

/**
 * @summary Adopt a charger
 */
export const useAdoptCharger = <
  TError = ProblemDetailsOfChargerAdoptionError[] | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adoptCharger>>,
    TError,
    { data: AdoptChargerRequest },
    TContext
  >;
}) => {
  const mutationOptions = getAdoptChargerMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get all schedules
 * @summary Get all schedules
 */
export const getSchedules = (chargerId: string, signal?: AbortSignal) => {
  return profileInstance<GetSchedulesResponse>({
    url: `/chargers/${chargerId}/schedules`,
    method: "GET",
    signal,
  });
};

export const getGetSchedulesQueryKey = (chargerId: string) => {
  return [`/chargers/${chargerId}/schedules`] as const;
};

export const getGetSchedulesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSchedules>>,
  TError = void | ProblemDetails,
>(
  chargerId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSchedules>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSchedulesQueryKey(chargerId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchedules>>> = ({
    signal,
  }) => getSchedules(chargerId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!chargerId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSchedules>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSchedulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSchedules>>
>;
export type GetSchedulesQueryError = void | ProblemDetails;

/**
 * @summary Get all schedules
 */
export const useGetSchedules = <
  TData = Awaited<ReturnType<typeof getSchedules>>,
  TError = void | ProblemDetails,
>(
  chargerId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSchedules>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSchedulesQueryOptions(chargerId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetSchedulesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSchedules>>,
  TError = void | ProblemDetails,
>(
  chargerId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSchedules>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSchedulesQueryKey(chargerId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchedules>>> = ({
    signal,
  }) => getSchedules(chargerId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!chargerId,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getSchedules>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSchedulesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSchedules>>
>;
export type GetSchedulesSuspenseQueryError = void | ProblemDetails;

/**
 * @summary Get all schedules
 */
export const useGetSchedulesSuspense = <
  TData = Awaited<ReturnType<typeof getSchedules>>,
  TError = void | ProblemDetails,
>(
  chargerId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSchedules>>,
        TError,
        TData
      >
    >;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSchedulesSuspenseQueryOptions(chargerId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * An endTime < startTime implies that the endTime is on the next day
 * @summary Create a schedule
 */
export const createSchedule = (
  chargerId: string,
  createScheduleRequest: CreateScheduleRequest,
) => {
  return profileInstance<CreateScheduleResponse>({
    url: `/chargers/${chargerId}/schedules`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createScheduleRequest,
  });
};

export const getCreateScheduleMutationOptions = <
  TError = ProblemDetailsOfScheduleError[] | void | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSchedule>>,
    TError,
    { chargerId: string; data: CreateScheduleRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSchedule>>,
  TError,
  { chargerId: string; data: CreateScheduleRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSchedule>>,
    { chargerId: string; data: CreateScheduleRequest }
  > = (props) => {
    const { chargerId, data } = props ?? {};

    return createSchedule(chargerId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSchedule>>
>;
export type CreateScheduleMutationBody = CreateScheduleRequest;
export type CreateScheduleMutationError =
  | ProblemDetailsOfScheduleError[]
  | void
  | ProblemDetails;

/**
 * @summary Create a schedule
 */
export const useCreateSchedule = <
  TError = ProblemDetailsOfScheduleError[] | void | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSchedule>>,
    TError,
    { chargerId: string; data: CreateScheduleRequest },
    TContext
  >;
}) => {
  const mutationOptions = getCreateScheduleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Update a schedule
 * @summary Update a schedule
 */
export const updateSchedule = (
  chargerId: string,
  scheduleId: string,
  updateScheduleRequest: UpdateScheduleRequest,
) => {
  return profileInstance<UpdateScheduleResponse>({
    url: `/chargers/${chargerId}/schedules/${scheduleId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateScheduleRequest,
  });
};

export const getUpdateScheduleMutationOptions = <
  TError = void | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSchedule>>,
    TError,
    { chargerId: string; scheduleId: string; data: UpdateScheduleRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSchedule>>,
  TError,
  { chargerId: string; scheduleId: string; data: UpdateScheduleRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSchedule>>,
    { chargerId: string; scheduleId: string; data: UpdateScheduleRequest }
  > = (props) => {
    const { chargerId, scheduleId, data } = props ?? {};

    return updateSchedule(chargerId, scheduleId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSchedule>>
>;
export type UpdateScheduleMutationBody = UpdateScheduleRequest;
export type UpdateScheduleMutationError = void | ProblemDetails;

/**
 * @summary Update a schedule
 */
export const useUpdateSchedule = <
  TError = void | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSchedule>>,
    TError,
    { chargerId: string; scheduleId: string; data: UpdateScheduleRequest },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateScheduleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Delete a schedule
 * @summary Delete a schedule
 */
export const deleteSchedule = (chargerId: string, scheduleId: string) => {
  return profileInstance<void>({
    url: `/chargers/${chargerId}/schedules/${scheduleId}`,
    method: "DELETE",
  });
};

export const getDeleteScheduleMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSchedule>>,
    TError,
    { chargerId: string; scheduleId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSchedule>>,
  TError,
  { chargerId: string; scheduleId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSchedule>>,
    { chargerId: string; scheduleId: string }
  > = (props) => {
    const { chargerId, scheduleId } = props ?? {};

    return deleteSchedule(chargerId, scheduleId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSchedule>>
>;

export type DeleteScheduleMutationError = ProblemDetails;

/**
 * @summary Delete a schedule
 */
export const useDeleteSchedule = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSchedule>>,
    TError,
    { chargerId: string; scheduleId: string },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteScheduleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Stop an active charging session
 * @summary Stop an active charging session
 */
export const stopChargingSession = (chargerId: string) => {
  return profileInstance<void>({
    url: `/chargers/${chargerId}/sessions/stop`,
    method: "POST",
  });
};

export const getStopChargingSessionMutationOptions = <
  TError = ProblemDetailsOfChargingSessionError | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stopChargingSession>>,
    TError,
    { chargerId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stopChargingSession>>,
  TError,
  { chargerId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stopChargingSession>>,
    { chargerId: string }
  > = (props) => {
    const { chargerId } = props ?? {};

    return stopChargingSession(chargerId);
  };

  return { mutationFn, ...mutationOptions };
};

export type StopChargingSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof stopChargingSession>>
>;

export type StopChargingSessionMutationError =
  | ProblemDetailsOfChargingSessionError
  | ProblemDetails;

/**
 * @summary Stop an active charging session
 */
export const useStopChargingSession = <
  TError = ProblemDetailsOfChargingSessionError | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stopChargingSession>>,
    TError,
    { chargerId: string },
    TContext
  >;
}) => {
  const mutationOptions = getStopChargingSessionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get chargers
 * @summary Get chargers
 */
export const getChargers = (signal?: AbortSignal) => {
  return profileInstance<GetChargersResponse[]>({
    url: `/chargers`,
    method: "GET",
    signal,
  });
};

export const getGetChargersQueryKey = () => {
  return [`/chargers`] as const;
};

export const getGetChargersQueryOptions = <
  TData = Awaited<ReturnType<typeof getChargers>>,
  TError = ProblemDetails | void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getChargers>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChargersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChargers>>> = ({
    signal,
  }) => getChargers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChargers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChargersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChargers>>
>;
export type GetChargersQueryError = ProblemDetails | void;

/**
 * @summary Get chargers
 */
export const useGetChargers = <
  TData = Awaited<ReturnType<typeof getChargers>>,
  TError = ProblemDetails | void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getChargers>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetChargersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetChargersSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getChargers>>,
  TError = ProblemDetails | void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getChargers>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChargersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChargers>>> = ({
    signal,
  }) => getChargers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getChargers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChargersSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChargers>>
>;
export type GetChargersSuspenseQueryError = ProblemDetails | void;

/**
 * @summary Get chargers
 */
export const useGetChargersSuspense = <
  TData = Awaited<ReturnType<typeof getChargers>>,
  TError = ProblemDetails | void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getChargers>>,
      TError,
      TData
    >
  >;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetChargersSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Get charger summary
 * @summary Get charger summary
 */
export const getChargerSummary = (chargerId: string, signal?: AbortSignal) => {
  return profileInstance<GetChargerSummaryResponse>({
    url: `/chargers/${chargerId}/summary`,
    method: "GET",
    signal,
  });
};

export const getGetChargerSummaryQueryKey = (chargerId: string) => {
  return [`/chargers/${chargerId}/summary`] as const;
};

export const getGetChargerSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getChargerSummary>>,
  TError = ProblemDetails | void,
>(
  chargerId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChargerSummary>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetChargerSummaryQueryKey(chargerId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getChargerSummary>>
  > = ({ signal }) => getChargerSummary(chargerId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!chargerId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getChargerSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChargerSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChargerSummary>>
>;
export type GetChargerSummaryQueryError = ProblemDetails | void;

/**
 * @summary Get charger summary
 */
export const useGetChargerSummary = <
  TData = Awaited<ReturnType<typeof getChargerSummary>>,
  TError = ProblemDetails | void,
>(
  chargerId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChargerSummary>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetChargerSummaryQueryOptions(chargerId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetChargerSummarySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getChargerSummary>>,
  TError = ProblemDetails | void,
>(
  chargerId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getChargerSummary>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetChargerSummaryQueryKey(chargerId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getChargerSummary>>
  > = ({ signal }) => getChargerSummary(chargerId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!chargerId,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getChargerSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChargerSummarySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChargerSummary>>
>;
export type GetChargerSummarySuspenseQueryError = ProblemDetails | void;

/**
 * @summary Get charger summary
 */
export const useGetChargerSummarySuspense = <
  TData = Awaited<ReturnType<typeof getChargerSummary>>,
  TError = ProblemDetails | void,
>(
  chargerId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getChargerSummary>>,
        TError,
        TData
      >
    >;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetChargerSummarySuspenseQueryOptions(
    chargerId,
    options,
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Opt in or out of marketing subscriptions
 * @summary Opt in or out of marketing subscriptions
 */
export const marketingSubscriptions = (
  marketingSubscriptionRequest: MarketingSubscriptionRequest,
) => {
  return profileInstance<void>({
    url: `/customer/profile/marketing-subscriptions`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: marketingSubscriptionRequest,
  });
};

export const getMarketingSubscriptionsMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof marketingSubscriptions>>,
    TError,
    { data: MarketingSubscriptionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof marketingSubscriptions>>,
  TError,
  { data: MarketingSubscriptionRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof marketingSubscriptions>>,
    { data: MarketingSubscriptionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return marketingSubscriptions(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarketingSubscriptionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof marketingSubscriptions>>
>;
export type MarketingSubscriptionsMutationBody = MarketingSubscriptionRequest;
export type MarketingSubscriptionsMutationError = ProblemDetails;

/**
 * @summary Opt in or out of marketing subscriptions
 */
export const useMarketingSubscriptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof marketingSubscriptions>>,
    TError,
    { data: MarketingSubscriptionRequest },
    TContext
  >;
}) => {
  const mutationOptions = getMarketingSubscriptionsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get historical charging sessions
 * @summary Get historical charging sessions
 */
export const getChargingSessions = (
  chargerId: string,
  params: GetChargingSessionsParams,
  signal?: AbortSignal,
) => {
  return profileInstance<GetChargingSessionsResponse[]>({
    url: `/chargers/${chargerId}/sessions`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetChargingSessionsQueryKey = (
  chargerId: string,
  params: GetChargingSessionsParams,
) => {
  return [
    `/chargers/${chargerId}/sessions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetChargingSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getChargingSessions>>,
  TError = ProblemDetailsOfGetChargingSessionsError | ProblemDetails | void,
>(
  chargerId: string,
  params: GetChargingSessionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChargingSessions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetChargingSessionsQueryKey(chargerId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getChargingSessions>>
  > = ({ signal }) => getChargingSessions(chargerId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!chargerId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getChargingSessions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChargingSessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChargingSessions>>
>;
export type GetChargingSessionsQueryError =
  | ProblemDetailsOfGetChargingSessionsError
  | ProblemDetails
  | void;

/**
 * @summary Get historical charging sessions
 */
export const useGetChargingSessions = <
  TData = Awaited<ReturnType<typeof getChargingSessions>>,
  TError = ProblemDetailsOfGetChargingSessionsError | ProblemDetails | void,
>(
  chargerId: string,
  params: GetChargingSessionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChargingSessions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetChargingSessionsQueryOptions(
    chargerId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetChargingSessionsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getChargingSessions>>,
  TError = ProblemDetailsOfGetChargingSessionsError | ProblemDetails | void,
>(
  chargerId: string,
  params: GetChargingSessionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getChargingSessions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetChargingSessionsQueryKey(chargerId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getChargingSessions>>
  > = ({ signal }) => getChargingSessions(chargerId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!chargerId,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getChargingSessions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChargingSessionsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChargingSessions>>
>;
export type GetChargingSessionsSuspenseQueryError =
  | ProblemDetailsOfGetChargingSessionsError
  | ProblemDetails
  | void;

/**
 * @summary Get historical charging sessions
 */
export const useGetChargingSessionsSuspense = <
  TData = Awaited<ReturnType<typeof getChargingSessions>>,
  TError = ProblemDetailsOfGetChargingSessionsError | ProblemDetails | void,
>(
  chargerId: string,
  params: GetChargingSessionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getChargingSessions>>,
        TError,
        TData
      >
    >;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetChargingSessionsSuspenseQueryOptions(
    chargerId,
    params,
    options,
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Override schedules to start charging immediately
 * @summary Override schedules to start charging immediately
 */
export const overrideSchedules = (chargerId: string) => {
  return profileInstance<void>({
    url: `/chargers/${chargerId}/schedules/override`,
    method: "POST",
  });
};

export const getOverrideSchedulesMutationOptions = <
  TError = ProblemDetailsOfOverrideSchedulesError | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof overrideSchedules>>,
    TError,
    { chargerId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof overrideSchedules>>,
  TError,
  { chargerId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof overrideSchedules>>,
    { chargerId: string }
  > = (props) => {
    const { chargerId } = props ?? {};

    return overrideSchedules(chargerId);
  };

  return { mutationFn, ...mutationOptions };
};

export type OverrideSchedulesMutationResult = NonNullable<
  Awaited<ReturnType<typeof overrideSchedules>>
>;

export type OverrideSchedulesMutationError =
  | ProblemDetailsOfOverrideSchedulesError
  | ProblemDetails;

/**
 * @summary Override schedules to start charging immediately
 */
export const useOverrideSchedules = <
  TError = ProblemDetailsOfOverrideSchedulesError | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof overrideSchedules>>,
    TError,
    { chargerId: string },
    TContext
  >;
}) => {
  const mutationOptions = getOverrideSchedulesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Refresh charger
 * @summary Refresh charger
 */
export const refreshCharger = (chargerId: string) => {
  return profileInstance<void>({
    url: `/chargers/${chargerId}/refresh`,
    method: "POST",
  });
};

export const getRefreshChargerMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshCharger>>,
    TError,
    { chargerId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshCharger>>,
  TError,
  { chargerId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshCharger>>,
    { chargerId: string }
  > = (props) => {
    const { chargerId } = props ?? {};

    return refreshCharger(chargerId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshChargerMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshCharger>>
>;

export type RefreshChargerMutationError = ProblemDetails;

/**
 * @summary Refresh charger
 */
export const useRefreshCharger = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshCharger>>,
    TError,
    { chargerId: string },
    TContext
  >;
}) => {
  const mutationOptions = getRefreshChargerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getGetCustomerProfileMock = () => ({
  contactId: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  email: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  firstName: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  lastName: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  mobile: faker.helpers.arrayElement([faker.word.sample(), undefined]),
});

export const getAdoptChargerMock = () => ({
  chargerId: faker.helpers.arrayElement([faker.word.sample(), undefined]),
});

export const getGetSchedulesMock = () =>
  Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    daysOfWeek: faker.helpers.arrayElement([
      faker.helpers.arrayElements(Object.values(DayOfWeek)),
      undefined,
    ]),
    description: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    endTime: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    startTime: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  }));

export const getCreateScheduleMock = () => ({
  daysOfWeek: faker.helpers.arrayElement([
    faker.helpers.arrayElements(Object.values(DayOfWeek)),
    undefined,
  ]),
  description: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  endTime: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  startTime: faker.helpers.arrayElement([faker.word.sample(), undefined]),
});

export const getUpdateScheduleMock = () => ({
  daysOfWeek: faker.helpers.arrayElement([
    faker.helpers.arrayElements(Object.values(DayOfWeek)),
    undefined,
  ]),
  description: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  endTime: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  startTime: faker.helpers.arrayElement([faker.word.sample(), undefined]),
});

export const getGetChargersMock = () =>
  Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    status: faker.helpers.arrayElement([
      faker.helpers.arrayElement(Object.values(ChargerStatus)),
      undefined,
    ]),
  }));

export const getGetChargerSummaryMock = () => ({
  activeChargeSession: faker.helpers.arrayElement([
    {
      chargingRateInKw: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      startDateTime: faker.helpers.arrayElement([
        `${faker.date.past().toISOString().split(".")[0]}Z`,
        undefined,
      ]),
      totalEnergyUsageInKwh: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    },
    undefined,
  ]),
  eTag: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  lastChargeSession: faker.helpers.arrayElement([
    {
      endDateTime: faker.helpers.arrayElement([
        `${faker.date.past().toISOString().split(".")[0]}Z`,
        undefined,
      ]),
      id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      startDateTime: faker.helpers.arrayElement([
        `${faker.date.past().toISOString().split(".")[0]}Z`,
        undefined,
      ]),
      totalEnergyUsageInKwh: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    },
    undefined,
  ]),
  location: faker.helpers.arrayElement([
    {
      addressLine: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      city: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      postcode: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      state: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      timeZone: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  serialNumber: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  status: faker.helpers.arrayElement([
    faker.helpers.arrayElement(Object.values(ChargerStatus)),
    undefined,
  ]),
});

export const getGetChargingSessionsMock = () =>
  Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    date: faker.helpers.arrayElement([
      `${faker.date.past().toISOString().split(".")[0]}Z`,
      undefined,
    ]),
    numberOfChargeSessions: faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      undefined,
    ]),
    totalEnergyUsageInKwh: faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      undefined,
    ]),
  }));

export const getHomeChargingServicesAPIV10Mock = () => [
  http.post("*/customer/profile", async () => {
    await delay(1000);
    return new HttpResponse(null, {
      status: 200,
      headers: {
        "Content-Type": "text/plain",
      },
    });
  }),
  http.get("*/customer/profile", async () => {
    await delay(1000);
    return new HttpResponse(getGetCustomerProfileMock(), {
      status: 200,
      headers: {
        "Content-Type": "text/plain",
      },
    });
  }),
  http.post("*/chargers/adopt", async () => {
    await delay(1000);
    return new HttpResponse(getAdoptChargerMock(), {
      status: 200,
      headers: {
        "Content-Type": "text/plain",
      },
    });
  }),
  http.get("*/chargers/:chargerId/schedules", async () => {
    await delay(1000);
    return new HttpResponse(JSON.stringify(getGetSchedulesMock()), {
      status: 200,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }),
  http.post("*/chargers/:chargerId/schedules", async () => {
    await delay(1000);
    return new HttpResponse(JSON.stringify(getCreateScheduleMock()), {
      status: 200,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }),
  http.put("*/chargers/:chargerId/schedules/:scheduleId", async () => {
    await delay(1000);
    return new HttpResponse(JSON.stringify(getUpdateScheduleMock()), {
      status: 200,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }),
  http.delete("*/chargers/:chargerId/schedules/:scheduleId", async () => {
    await delay(1000);
    return new HttpResponse(null, {
      status: 200,
      headers: {
        "Content-Type": "text/plain",
      },
    });
  }),
  http.post("*/chargers/:chargerId/sessions/stop", async () => {
    await delay(1000);
    return new HttpResponse(null, {
      status: 200,
      headers: {
        "Content-Type": "text/plain",
      },
    });
  }),
  http.get("*/chargers", async () => {
    await delay(1000);
    return new HttpResponse(getGetChargersMock(), {
      status: 200,
      headers: {
        "Content-Type": "text/plain",
      },
    });
  }),
  http.get("*/chargers/:chargerId/summary", async () => {
    await delay(1000);
    return new HttpResponse(getGetChargerSummaryMock(), {
      status: 200,
      headers: {
        "Content-Type": "text/plain",
      },
    });
  }),
  http.put("*/customer/profile/marketing-subscriptions", async () => {
    await delay(1000);
    return new HttpResponse(null, {
      status: 200,
      headers: {
        "Content-Type": "text/plain",
      },
    });
  }),
  http.get("*/chargers/:chargerId/sessions", async () => {
    await delay(1000);
    return new HttpResponse(getGetChargingSessionsMock(), {
      status: 200,
      headers: {
        "Content-Type": "text/plain",
      },
    });
  }),
  http.post("*/chargers/:chargerId/schedules/override", async () => {
    await delay(1000);
    return new HttpResponse(null, {
      status: 200,
      headers: {
        "Content-Type": "text/plain",
      },
    });
  }),
  http.post("*/chargers/:chargerId/refresh", async () => {
    await delay(1000);
    return new HttpResponse(null, {
      status: 200,
      headers: {
        "Content-Type": "text/plain",
      },
    });
  }),
];
